import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, Lock, Download } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
const items = [{
  text: '📘 El Azúcar Silencioso (libro principal)',
  price: '$27.00'
}, {
  text: '🎁 Bono 1: El Azúcar Infantil',
  price: '$9.95'
}, {
  text: '🎁 Bono 2: Regula el Cortisol',
  price: '$9.95'
}, {
  text: '🎁 Bono 3: Guía del Hogar sin Azúcar Oculta',
  price: '$9.95'
}];
export function FinalOffer() {
  return <section id="comprar" className="relative bg-ivory py-[40px] md:py-[64px] px-6 overflow-hidden" data-id="element-100">
      {/* Section Separator */}
      <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-b from-white to-transparent opacity-10 pointer-events-none z-20" data-id="element-101"></div>

      {/* Warm radial glow */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 70% 50% at 50% 100%, rgba(180,83,9,0.20) 0%, transparent 70%)'
    }} data-id="element-102"></div>

      <div className="relative z-10 max-w-[720px] mx-auto" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-104">
          <div className="mb-8" data-id="element-105">
            <img src="https://cdn.magicpatterns.com/uploads/trMZyZdHEebn8CBUEsiEnE/Imagen_Landing_Bono_Combo.png" alt="Combo completo de ebooks: El Azúcar Silencioso + 3 bonos" className="w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-106" />
          </div>

          <p className="font-mono text-[11px] tracking-[0.15em] text-cocoa uppercase mb-6 text-center" data-id="element-107">
            OFERTA COMPLETA
          </p>

          <h2 className="font-serif font-black text-[38px] md:text-[42px] leading-[1.2] text-text-primary mb-8 text-center" data-id="element-108">
            Todo lo que recibes hoy.
          </h2>

          {/* Price Table */}
          <div className="bg-surface border border-border rounded-[6px] p-6 md:p-8 mb-10 shadow-sm" data-id="element-109">
            <div className="space-y-4" data-id="element-110">
              {items.map((item, index) => <div key={index} className="flex justify-between items-center border-b border-border-light pb-4 last:border-0 last:pb-0" data-id="element-111">
                  <span className="font-mono text-[13px] md:text-[14px] text-text-secondary" data-id="element-112">
                    {item.text}
                  </span>
                  <span className="font-mono text-[14px] text-text-muted line-through whitespace-nowrap ml-4" data-id="element-113">
                    {item.price}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="text-center mb-10" data-id="element-114">
            <p className="font-mono text-[12px] text-cocoa uppercase mb-4" data-id="element-115">
              PRECIO POR TIEMPO LIMITADO
            </p>

            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-116">
              <span className="font-mono text-[14px] text-text-muted line-through" data-id="element-117">
                Valor total: $56.85
              </span>
            </div>

            <div className="flex flex-col items-center justify-center mb-4" data-id="element-118">
              <span className="font-mono text-[14px] text-text-muted mb-2" data-id="element-119">
                Hoy por solo:
              </span>
              <span className="font-serif font-black text-[80px] leading-none text-cocoa" data-id="element-120">
                $17.95
              </span>
            </div>

            <p className="text-sage text-[13px] font-medium" data-id="element-121">
              Ahorras $39.85 · Precio especial por tiempo limitado
            </p>
          </div>

          <div className="max-w-[460px] mx-auto" data-id="element-122">
            <a href="https://godeskcore.com/products/el-azucar-silenciosa" onClick={() => trackAddToCart()} className="premium-btn-cocoa block w-full" data-id="element-123">
              Descargar Ahora — $17.95
            </a>

            <p className="font-sans text-[12px] text-text-muted text-center mt-4 mb-6" data-id="element-124">
              Precio de lanzamiento · $17.95 sube a $19.95 después de las
              primeras 50 ventas
            </p>

            <p className="font-sans italic text-[13px] text-text-muted text-center mb-8" data-id="element-125">
              "Una consulta médica en USA cuesta entre $150 y $400.
              <br data-id="element-126" />
              En esos 15 minutos no recibirás la explicación que este libro te
              da."
            </p>

            <div className="flex items-center justify-center gap-6 text-text-muted" data-id="element-127">
              <div className="flex items-center gap-2" data-id="element-128">
                <CreditCard className="w-4 h-4" data-id="element-129" />
                <span className="font-mono text-[11px]" data-id="element-130">Tarjetas</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-131">
                <Lock className="w-4 h-4" data-id="element-132" />
                <span className="font-mono text-[11px]" data-id="element-133">Seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-134">
                <Download className="w-4 h-4" data-id="element-135" />
                <span className="font-mono text-[11px]" data-id="element-136">Inmediato</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}